<div class="main-container" style="background-color: #ffffff;">
  <div class="content-wrapper">
    <div class="container">
      <!-- Search Row -->
      <div class="row">
        <div class="col-md-6 col-lg-4" style="margin-top: 10px;">
          <label class="fieldName " style="font-size: 12px;">SEARCH</label>
          <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center">
            <input
              type="text"
              [(ngModel)]="searchText"
              placeholder="Search"
              class="form-control"
              style="min-width: 200px; margin-bottom: 10px;"
            />
            <button
              class="btn btn-primary mt-2 mt-md-0 ms-md-2 book-now-btn"
              (click)="search()"
            >
              Search
            </button>
          </div>
        </div>
      </div>

      <!-- Grid Row -->
      <div class="row" *ngIf="SA">
        <div class="col">
          <div class="users" style="margin-top: 25px;">
            <ag-grid-angular
              style="width: 100%; height: 800px;"
              class="ag-theme-alpine"
              [rowData]="filteredUsersData"
              [columnDefs]="gridOptions.columnDefs"
              [gridOptions]="gridOptions"
            >
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Edit User Modal -->
<div class="modal fade show d-block" tabindex="-1" role="dialog" *ngIf="showEditModal">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ isEditMode ? 'Edit User' : 'User Profile' }}
          <span *ngIf="selectedUser?.email" class="text-muted ms-2">
            {{ selectedUser.email }}
          </span>
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeEditModal()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="profileForm" (ngSubmit)="saveUserChanges()" >
          <div class="form-group col-md-6" >
            <label style="margin-top: 10px;">First Name</label>
            <input class="form-control" formControlName="firstName">
          </div>

          <div class="form-group mt-2 col-md-6">
            <label>Last Name</label>
            <input class="form-control" formControlName="lastName">
          </div>

          <div class="form-group mt-2 col-md-6">
            <label>Phone Number</label>
            <input class="form-control" formControlName="phoneNumber">
            <div *ngIf="profileForm.controls.phoneNumber.invalid && profileForm.controls.phoneNumber.touched" class="text-danger">
              Enter a valid 10-digit phone number
            </div>
          </div>
          <div class="form-group mt-2 col-md-6">
            <label>Role</label>

            <!-- View Mode -->
            <input class="form-control" [value]="roleMap[profileForm.get('roleId')?.value] || 'N/A'" disabled *ngIf="!isEditMode">

            <!-- Edit Mode -->
            <select class="form-control" formControlName="roleId" *ngIf="isEditMode">
              <option *ngFor="let role of roleOptions" [value]="role.id">
                {{ role.label }}
              </option>
            </select>
          </div>
          <!-- Tenant ID (shown only when role is Tenant Admin) -->
          <div class="form-group mt-2 col-md-6" *ngIf="profileForm.get('roleId')?.value == 2">
            <label>Tenant</label>

            <!-- View Mode: Show tenant name -->
            <input
              class="form-control"
              [value]="getTenantName(profileForm.get('tenantId')?.value)"
              disabled
              *ngIf="!isEditMode"
            >

            <!-- Edit Mode: Dropdown -->
            <select class="form-control" formControlName="tenantId" *ngIf="isEditMode">
              <option *ngFor="let tenant of tenants" [value]="tenant.id">
                {{ tenant.tenantName }}
              </option>
            </select>
          </div>

          <div class="mt-3">
            <button class="btn btn-primary me-2 pop-up-btn-blue" type="button" *ngIf="!isEditMode" (click)="toggleEdit()">Edit</button>
            <button class="btn btn-success" type="submit" *ngIf="isEditMode" [disabled]="isLoading || profileForm.invalid">
              {{ isLoading ? 'Saving...' : 'Save' }}
            </button>
            <button class="btn btn-secondary ms-2" type="button" *ngIf="isEditMode" (click)="toggleEdit()">Cancel</button>
          </div>
        </form>
<!--        <form>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label>First Name</label>
              <input class="form-control" [(ngModel)]="selectedUser.firstName" name="firstName">
            </div>
            <div class="col-md-6 mb-3">
              <label>Last Name</label>
              <input class="form-control" [(ngModel)]="selectedUser.lastName" name="lastName">
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label>Phone Number</label>
              <input class="form-control" [(ngModel)]="selectedUser.phoneNumber" name="phoneNumber">
            </div>
          </div>

          <div class="row" *ngIf="SA">
            <div class="col-md-6 mb-3">
              <label>Role ID</label>
              <input class="form-control" [(ngModel)]="selectedUser.roleId" name="roleId">
            </div>
            <div class="col-md-6 mb-3">
              <label>Tenant ID</label>
              <input class="form-control" [(ngModel)]="selectedUser.tenantId" name="tenantId">
            </div>
          </div>
        </form>-->
      </div>
<!--      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeEditModal()">Cancel</button>
        <button class="btn btn-primary" (click)="saveUserChanges()">Save</button>
      </div>-->
    </div>
  </div>
</div>
<div class="modal-backdrop fade show" *ngIf="showEditModal"></div>


<!--<div class="main-container" style= "background-color: #ffffff;">
  <div class= "content-wrapper">
    <div class="container">

      <div class="row" >
        <div class="col-md-4" style="margin-top:10px;">
          <label  class="fieldName" style="font-size:12px;" >SEARCH</label>
          <div class = "row" style="height:10px; margin-bottom:10px; margin-left:5px;">
            <input style="min-width: 200px;" type="text" [(ngModel)]="searchText" placeholder="Search">
            <button style="margin-left: 10px;" (click)="search()">Search</button>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="SA">
        <div class="col">
          <div class= "users" style="margin-top: 25px;">
            <ag-grid-angular
              style="width: 100%; height: 800px;"
              class="ag-theme-alpine"
              [rowData]="usersData"
              [columnDefs]="gridOptions.columnDefs"
              [gridOptions]="gridOptions"
            >
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>-->
<router-outlet></router-outlet>
